import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=6ec21ba4&scoped=true&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&id=6ec21ba4&lang=scss&scoped=true&"
import style1 from "./invoiceDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec21ba4",
  null
  
)

export default component.exports